<template>
  <section>
    <div class="son_shouxin">
      <div class="title flex ">
        <div class="color-primary">授信余额：{{(shouxin.authmoney-shouxin.authusedall).toFixed(2)}}</div>
        <!-- <div class="color-primary flex">
          <span>授信余额：1000</span>
        </div> -->
      </div>
      <div class="son_list flex ju-be">
        <div class="son_item" v-for="(item, index) in accountList.data" :key="index">
          <div class="sonName flex">
            <span class="company bold12">{{item.title}}</span> &nbsp; &nbsp;
            <span class="normal12">账单日: {{item.authdate?'每月'+item.authdate+'日':'暂未设置'}}</span> &nbsp; &nbsp;
            <span class="normal12">有效期：{{item.timeto?'每月'+item.timeto+'日':'暂未设置'}}</span>
          </div>
          <div class="sonData flex ju-ar">
            <li class="sonData_item">
              <span class="bold18">{{item.authmoney}}</span>
              <br />
              <span class="normal12">企业额度(元)</span>
            </li>
            <li class="sonData_item">
              <span class="bold18">{{item.authused}}</span>
              <br />
              <span class="normal12">已用额度(元)</span>
            </li>
            <li class="sonData_item">
              <span class="bold18">{{(parseFloat(item.authmoney)*100-parseFloat(item.authused)*100)/100}}</span>
              <br />
              <span class="normal12">剩余额度(元)</span>
            </li>
          </div>
        </div>
      </div>
      <el-pagination
        class="fenye"
        background
        layout="prev, pager, next"
        :page-size="accountList.per_page"
        @current-change="currentPage"
        :total="accountList.total"
      ></el-pagination>
    </div>
  </section>
</template>

<script>
export default {
  name: "son_shouxin",
  data() {
    return {
      page: 1,
      accountList:{},
      shouxin:{},
    };
  },

  methods: {
    currentPage(e) {
      this.page = e;
      this.getaccountList();
    },
    async getaccountList() {// 授信表
      let accountList = await this.$fetch("shop/subaccount", {
        body: { act: "list",page:this.page }
      });
     
      console.log("授信表", accountList);
      this.accountList = accountList;
    }
  },

  async mounted() {
     this.getaccountList(); // 授信表
     this.shouxin = await this.$fetch("order/logintip");
  }
};
</script>

  


<style lang='scss' scoped>
</style>



// WEBPACK FOOTER //
// src/components/son_shouxin.vue